import { HelpCircle } from '@saleswhale/barnacle/icons';
import cn from 'classnames';
import { ReactNode } from 'react';
import { Tooltip6DS } from '../../SixSenseElements';
import styles from './AttributeItem.module.scss';

interface AttributeItemProps {
  header: ReactNode;
  body?: {
    content?: ReactNode;
    leftContent?: ReactNode;
    linkTo?: string;
    rightContent?: ReactNode;
    text?: string | number | null;
  };
  bodyClassName?: string;
  className?: string;
  testId?: string;
  tooltip?: string;
  tooltipTestId?: string;
}

export default function AttributeItem({
  header,
  body,
  tooltip,
  tooltipTestId = 'AttributeItem__popup',
  testId = 'AttributeItem',
  className = '',
  bodyClassName = '',
}: AttributeItemProps) {
  const t_tooltip = <span data-testid={tooltipTestId}>{tooltip}</span>;
  const renderItemBody = () => {
    if (!body) {
      return (
        <div className={styles.Value} data-testid={`${testId}__body`}>
          -
        </div>
      );
    }
    const { leftContent, rightContent, text, content } = body;
    return (
      <div className={styles.Value} data-testid={`${testId}__body`}>
        {leftContent}
        {content ||
          (text ? (
            <span className={cn(styles.ValueText, bodyClassName)} title={text.toString()}>
              {text}
            </span>
          ) : (
            '-'
          ))}
        {rightContent}
      </div>
    );
  };

  const itemBodyContent = renderItemBody();

  return (
    <div className={`${styles.ItemContainer} ${className}`} data-testid={testId}>
      <div className={styles.Title}>
        <span>{header}</span>
        {tooltip && (
          <Tooltip6DS showArrow overlay={t_tooltip} placement="bottom" trigger="hover">
            <HelpCircle className={styles.PopupIcon} data-testid={`${testId}Icon`} size={13} />
          </Tooltip6DS>
        )}
      </div>
      {body?.linkTo ? (
        <a href="/" rel="noopener noreferrer" target="_blank">
          {itemBodyContent}
        </a>
      ) : (
        itemBodyContent
      )}
    </div>
  );
}
